import { AloftPrice, isDefined } from '@aloft/toolkit-shared';
import { createSelector } from '@reduxjs/toolkit';

import { selectCompSequence } from '../orderSelectors.ts';
import { selectImprovementsEntities } from '../propertyDataSelectors/improvementsSelectors.ts';
import { selectManufacturedGLAAdjs } from './selectManufacturedGLAAdj.ts';
import { selectMultiFamilyGBAAdjs } from './selectMultiFamilyGBAdj.ts';
import { selectSFRGLAAdjs } from './selectSFRGLAAdj.ts';

export const selectAreaAdjs = createSelector(
  [
    selectImprovementsEntities,
    selectManufacturedGLAAdjs,
    selectMultiFamilyGBAAdjs,
    selectSFRGLAAdjs,
    selectCompSequence,
  ],
  (improvements, manufacturedGLAAdjs, multiFamilyGBAAdjs, sfrGLAAdjs, compSequence) => {
    return compSequence.reduce((acc: Record<string, AloftPrice>, propID) => {
      let adj;

      switch (improvements[propID]?.propertyType) {
        case 'multiFamily':
          adj = multiFamilyGBAAdjs[propID];
          break;
        case 'manufacturedHome':
          adj = manufacturedGLAAdjs[propID];
          break;
        default:
          adj = sfrGLAAdjs[propID];
          break;
      }

      if (isDefined(adj)) acc[propID] = adj;

      return acc;
    }, {});
  },
);
